export const objectToQueryParams = (obj: object) => {
  const queryString = new URLSearchParams(
    Object.entries(obj).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null) {
          acc[key] = String(value);
        }
        return acc;
      },
      {} as Record<string, string>
    )
  ).toString();

  return queryString;
};
